// components/auto-export-poezd/component
/* global DEBUG */

import template  from './component.jade'
import style from './style.scss'
import Store     from 'Store'
import parseUnixTime from 'lib/parseUnixTime'
import compareText from 'lib/sortArrays'
import datetimepicker from './datetimepicker'
import AutoCarrierList  from 'components/auto-carrier-list/component'
import AutoExportCnt  from 'components/auto-export-cnt/component'
import SlotsAuto  from 'components/slots-auto/component'
import AutoList  from 'components/auto-list/component'

let name = 'auto-export-poezd';
let url = '/api/AutoExportPoezd';

let status = [
    ' сформирована',
    ' находится в обработке',
    ' выполнена',
    ' отменена',
    ' не сформирована',
];

const store = new Store(name);


export default {
    name: name,
    template: template({style: style}),

    data: () => ({
        name: name,
        url: url,
        autocarriers: null,
        autoLists: null,
        slots: null,
        sklad:null,
        show: true,
        blockForm: false,
        errors: '',
        date_plan: null,
        disabled: false,
        exportCnt:null,
        order_phone:null,
        order_email:null,
    }),

    ready() {
        datetimepicker(style);
        let currentDate = new Date().getTime() / 1000;
        this.$set(`date_plan`, parseUnixTime(currentDate, 'dateVs'));
        this.getAutoCarrierList();
        this.$set('responsible_phone',store.$get('phone'));
        this.$set('responsible_email',store.$get('email'));
        this.$set('cnt_load', 'груженый');

    },
    methods: {
        getSlotsList(date, cntLoad){
            this.slots = null;
            let slotsAutoList = new Vue(SlotsAuto);
            console.log(date);
            slotsAutoList.$emit('slots-auto:slots-auto', {
                name: 'slots-auto',
                sklad: this.sklad,
                zavoz: false,
                cnt_load: cntLoad,
                date_oper: date.split(' ')[0].split('-').reverse().join('-')+'T'+parseUnixTime(new Date().getTime() / 1000, 'timeOnly')
            });
            this.$set('slotsAutoList', slotsAutoList.$data);
        },
        getAutoCarrierList(){
            let autoCarrierList = new Vue(AutoCarrierList);
            autoCarrierList.$emit('auto-carrier:auto-carrier-list', {
                name: 'auto-carrier-list',
            });
            this.$set('autoCarrierList', autoCarrierList.$data);
        },
        getAutoList(code){
            let autoList = new Vue(AutoList);
            autoList.$emit('auto-list:auto-list', {
                Kod_AutoCarrier: code,
            });
            this.$set('autoList', autoList.$data);
        },
        submit(e) {
            e.preventDefault();
            let formData = new FormData();
            let data = $(this.$$.form).serializeArray();
            let errors = '';
            //let datePlan = this.$get('date_plan');
            if (!this.$get('kod_autocarrier')) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Автоперевозчик"';
            $.each(data, function (i, field) {
                formData.append(field.name, field.value);
                if (field.name === 'Transport_plan' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Транспорт"';
                if (field.name === 'Voditel_plan' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Водитель"';
                if (field.name === 'responsible_phone' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Телефон"';
                if (field.name === 'responsible_email' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Email"'
            });
            formData.append('cnt_number', this.$get('number'));
            if (!this.$get('slot_plan')) this.$set('slot_plan', '');
            if (!this.$get('slot_plan').length){
                if (this.sklad ==='ПИК'){
                    errors += '<br />' + '&bull;&nbsp;не заполнено поле "Временной слот"';
                }else{
                    this.$set('slot_plan', '');
                }
            }

            let date = this.$get('date_plan').split(' ')[0].split('-').reverse().join('-'),
            time = this.$get('date_plan').split(' ')[1];
            if (!time){
                errors += '<br />' + '&bull;&nbsp;не указано время вывоза в поле "Дата и время вывоза" <br />&nbsp;&nbsp;&nbsp; Формат поля: '+ date+ ' 12:00'
            }
            formData.append('Date_plan', date +'T'+time+':00');
            formData.append('slot_plan', this.$get('slot_plan'));
            console.log('submit slot_plan', this.$get('slot_plan'));
            this.$set('data', formData);
            this.errors = errors;
            if (errors) {
                this.errors = 'Ошибка при обработке данных заявки!' + errors;
                this.$parent && this.$broadcast('alert', {
                    name: this.name, type: 'form.error', view: true
                })
            } else {
                this.$parent && this.$broadcast('alert', {
                    name: this.name, type: 'form.error', view: false
                });
              store.$save(this);
                this.errors = ''
            }
            this.blockForm = false
        },
        // при закрытии окна возвратимся по истории назад и сбросим форму
        onClick(e) {
            e.preventDefault();
            this.$set('show', true);
            let from = this.$route.router._currentTransition.from.name || 'index';
            this.$route.router.go({name: from})
        },
    },
    computed:{
      canEditOrder(){
          return (this.exportCnt.status !== 2)
      },

    },
    watch: {
        blockForm: {
            handler(value) {
                console.log('blockForm: ', value)
            },
            deep: false,
        },
        show: {
            handler(value) {
                console.log('show: ', value)
            },
            deep: false,
        },
        kod_autocarrier:{
            handler(value) {
                if (value){
                    this.getAutoList(value);
                }
            },
            deep: false,
        },

        // при получении данных о автоперевозчиках отсортируем
        // автоперевозчиков и создадим массив containers
        autoCarrierList: {
            handler() {
                let table = this.autoCarrierList.data.table;
                if (table) {
                    this.autocarriers = table.map(item => {
                        return {
                            value: item.kod,
                            text: item.name,
                        }
                    }).sort(compareText)
                }
            },
            deep: true,
        },
        slotsAutoList: {
            handler() {
                let table = this.slotsAutoList.data.table;
                if (table) {
                    this.slots = table.map(item => {
                        return item.name
                    })/*.sort(compareText)*/
                }
            },
            deep: true,
        },
        autoList: {
            handler() {
                let table = this.autoList.data.table;
                if (table) {
                    this.autoLists = table.map(item => {
                        return item.number
                    }).sort(compareText)
                }
            },
            deep: true,
        },
        autoExportCntInfo: {
            handler() {
                let data = this.autoExportCntInfo.data,
                    numbers = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
                if (data) {
                    this.exportCnt = data;
                    let date = (this.exportCnt.date) ? new Date(this.exportCnt.date * 1000): new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
                    this.$set('kod_autocarrier',this.exportCnt.autoCarrier );
                    this.$set('transport_plan',this.exportCnt.transport );
                    this.$set('voditel_plan',this.exportCnt.voditel );
                    this.$set('date_plan', (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())+'-'+numbers[date.getMonth()]+'-'+date.getFullYear()
                        + ' ' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
                        + ':'+ (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()));
                    this.$set('message_plan',this.exportCnt.message );
                    this.$set('statusMessage',status[this.exportCnt.date ? this.exportCnt.status: 4] );
                    this.$set('buttonText', this.exportCnt.date ? 'Изменить': 'Сформировать');
                    this.$set('responsible_phone',this.exportCnt.telephone);
                    this.$set('responsible_email',this.exportCnt.email);
                    let self= this;
                    setTimeout(function () {
                        if (self.slots && self.exportCnt.slot !== null) {
                            if (self.slots.indexOf(self.exportCnt.slot) === -1){
                                self.slots.unshift(self.exportCnt.slot);
                                self.slots.sort(compareText);
                            }
                        }
                        self.$set('slot_plan',self.exportCnt.slot);
                        if (self.autoLists) {
                            if (self.autoLists.indexOf(self.exportCnt.transport) === -1){
                                self.autoLists.unshift(self.exportCnt.transport);
                                self.autoLists.sort(compareText);
                            }
                        }
                        self.$set('transport_plan',self.exportCnt.transport );
                    }, 4000);
            }
        },
            deep: true,
        },
        sklad: {
            handler(value) {
                if (value === 'ПИК' && this.cnt_load){
                    this.getSlotsList(this.date_plan, this.cnt_load);
                }
            },
            deep: false,
        },
        cnt_load: {
            handler(value) {
                if (value && this.sklad === 'ПИК'){
                    this.getSlotsList(this.date_plan, this.cnt_load);
                }
            },
            deep: false,
        },
        slot_plan: {
            handler(value) {
                if (value){
                    this.$set('date_plan',value.split(' ')[0].replace('.','-').replace('.','-')+' '+value.split(' ')[1].split('-')[0]);
                }
            },
            deep: false,
        },
    },

    events: {
        // при вызове заявки из таблицы контейнеров cnt_poezd
        ['number:' + name]: function (data) {
            let {number: number, number: title, sklad:sklad} = data;
            this.$set('number', number);
            this.$set('title', title);
            this.sklad = sklad;
            this.$set('data', null);
            this.$set('data', data);
            let autoExportCntInfo = new Vue(AutoExportCnt);
            autoExportCntInfo.$emit('number:auto-export-cnt', {
                name: 'auto-export-cnt',
                number: this.number
            });
            this.$set('autoExportCntInfo', autoExportCntInfo.$data)

        },

        // если есть ошибки, скроем поля формы
        'fetchData:error': function () {
            this.$set('blockForm', false)
            this.$set('show', true)
        },
        // если все ок, скроем поля формы
        'fetchData:ok': function () {
            this.$set('errors', '');
            this.$set('blockForm', true);
            this.$set('show', false)
        },
    },

}




/** WEBPACK FOOTER **
 ** ./src/js/components/auto-export-poezd/component.js
 **/